import { Autocomplete, AutocompleteProps, Chip, TextField } from "@mui/material";
import { castArray } from "lodash";
import { Trailer } from "../../../../../graphql/generated";
import { ConditionValueSelectorComponentProps } from "../../ConditionForm";
import { testIds } from "./TrailerInput.testIds";
import activeOrSelected from "../../../../../utils/assets/activeOrSelected";

const TrailerInput = ({
  value,
  onChange,
  trailers,
  ...otherProps
}: ConditionValueSelectorComponentProps & {
  trailers: Pick<Trailer, "_id" | "serialNumber" | "status">[];
} & Pick<AutocompleteProps<string, true, undefined, undefined>, "sx">) => {
  // Rules saved before multiselect hold a single id, so always read a list.
  const selectedIds = castArray(value ?? []).filter(
    (id): id is string => typeof id === "string"
  );
  const selectableTrailers = activeOrSelected(trailers, selectedIds);
  return (
    <Autocomplete
      data-testid={testIds.trailerInputAutocomplete}
      disablePortal
      multiple
      options={selectableTrailers}
      getOptionLabel={(trailer) => trailer.serialNumber}
      renderTags={(value, getTagProps) =>
        value.map((trailer, index) => (
          <Chip
            label={trailer.serialNumber}
            {...getTagProps({ index })}
            data-testid={`${testIds.trailerInputAutocompleteTag}-${trailer.serialNumber}`}
            key={trailer._id}
          />
        ))
      }
      renderOption={(props, trailer) => (
        <li
          {...props}
          data-testid={testIds.trailerInputAutocompleteOption}
          data-value={trailer._id}
        >
          {trailer.serialNumber}
        </li>
      )}
      onChange={(event, value) => {
        onChange(value.map((trailer) => trailer._id));
      }}
      value={selectableTrailers.filter((trailer) =>
        selectedIds.includes(trailer._id)
      )}
      size="small"
      renderInput={(inputProps) => (
        <TextField
          {...inputProps}
          inputProps={{
            ...inputProps.inputProps,
            "data-testid": testIds.trailerInputAutocompleteInput,
          }}
        />
      )}
      sx={{
        minWidth: 300,
      }}
      {...otherProps}
    />
  );
};

export default TrailerInput;
